import useSmallScreen from "../../../../components/useSmallScreen";
import LiveStreamBottomLargeScreenControls from "./LiveStreamBottomLargeScreenControls";
import LiveStreamBottomSmallScreenControls from "./LiveStreamBottomSmallScreenControls";

function LiveStreamBottomControls({ showFullScreen, viewingLiveStream }) {
  const [smallScreen] = useSmallScreen();
  return smallScreen ? (
    <LiveStreamBottomSmallScreenControls
      showFullScreen={showFullScreen}
      viewingLiveStream={viewingLiveStream}
    />
  ) : (
    <LiveStreamBottomLargeScreenControls
      viewingLiveStream={viewingLiveStream}
    />
  );
}

export default LiveStreamBottomControls;
